module.exports = __webpack_public_path__ + "why10.webp?8a3408265082a1b95b206034a32b0e31";